import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import App from '../components/app';
import { appMount, appOutdated, appReload } from '../actions';

function mapStateToProps(state) {
  return {
    app: state.app,
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    appMount,
    appOutdated,
    appReload,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
